import React from 'react' 
import { Link } from 'react-router-dom' 
import Breadcrumb from '../Component/Breadcrumb'
import LazyLoad from 'react-lazyload'
const Pphelp = () => {
return (
<> 

<Breadcrumb breadtitle="Parent Guidelines" breadmid="" breadend="Parent Guidelines" />
<div className="innerpage">
   <div className="container flwidth">
      <div className='row'>
         <div class="col-md-12">
            <h1 class="head1">CampusCare® Application Guidelines &amp; Instructions</h1>
            <p class="guideheading">How to LOG IN Parent Portal?</p>
            <p class="details">1. Open Chrome 
            <div class="lazyload-wrapper ">
               <img src="https://webapi.entab.info/api/image/CSFL/public/images/google.png" alt="School ERP Software, Mobile App, School Management Software" class="img-fluid" />
            </div>
            OR Mozilla
            <div class="lazyload-wrapper ">
               <img src="https://webapi.entab.info/api/image/CSFL/public/images/mzilla.png" alt="School ERP Software, Mobile App, School Management Software" class="img-fluid" />
            </div>
            or Internet
            <div class="lazyload-wrapper ">
               <img alt="School ERP Software, Mobile App, School Management Software" src="https://webapi.entab.info/api/image/CSFL/public/images/internet.png" class="img-fluid" />
            </div>
            </p>
            <p class="details">2. Write the school URL <strong><a href="https://canossa.campuscare.info/" target="_blank">“canossa.campuscare.info/”</a>
               </strong> in address bar. (you will be routed to the Log In credential page).
            </p>
            <p class="details">
               3. Then, enter the USER ID and Click on "Next button", Then enter PASSWORD and Click on Sign in button.
            </p>
            <p class="details">Once logged in, you are welcomed with various information relating to assignments, news, circulars, date sheet, fee details etc. that are self explanatory. Wish you to go through every links that are provided and explore more.</p>
            <div class="p2"></div>
            <div>
               <p class="guideheading">How to make Online Payment ?</p>
               <p class="details">
                  <a href="https://smarthubeducation.hdfcbank.com/SmartFees/Landing.action?instId=LED" target="_blank">
                  <b>Click The Link </b></a>
               </p>
            </div>
            <p class="guideheading">How to RESET PASSWORD in Parent Portal? </p>
            <p class="details">1. Open Chrome 
            <div class="lazyload-wrapper ">
               <img src="https://webapi.entab.info/api/image/CSFL/public/images/google.png" alt="School ERP Software, Mobile App, School Management Software" class="img-fluid" />
            </div>
            OR Mozilla
            <div class="lazyload-wrapper ">
               <img src="https://webapi.entab.info/api/image/CSFL/public/images/mzilla.png" alt="School ERP Software, Mobile App, School Management Software" class="img-fluid" />
            </div>
            or Internet
            <div class="lazyload-wrapper "><img alt="School ERP Software, Mobile App, School Management Software" src="https://webapi.entab.info/api/image/CSFL/public/images/internet.png" class="img-fluid" /></div>
            </p>
            <p class="details">2. Write the school URL <strong><a href="https://canossa.campuscare.info/" target="_blank">“canossa.campuscare.info/”</a></strong> in address bar. (you will be routed to the Log In credential page).</p>
            <p class="details">3. Then, click on “Forgot User ID or Password?” text given below User ID field.</p>
            <p class="details">4. Select the User Type (For which you want a password) then Enter Registered Mobile No. and click on “Reset” Button.</p>
            <p class="details">5. You will get an SMS on your registered mobile no. along with login credentials.</p>
            <div class="clr10"></div>
            <div>
               <p class="guideheading">How to Install &amp; operate MOBILE APP? </p>
               <p class="details">1. Go to 
               <div class="lazyload-wrapper ">
                  <img alt="School ERP Software, Mobile App, School Management Software" src="https://webapi.entab.info/api/image/CSFL/public/images/playstore.png" />
               </div>
               Store /
               <div class="lazyload-wrapper "> 
                  <img alt="School ERP Software, Mobile App, School Management Software" src="https://webapi.entab.info/api/image/CSFL/public/images/apple.png" /> 
               </div>
               and Search "CampusCare®".</p>
               <p class="details">2. Install and open the <a href="https://www.entab.in/mobile-apps.html" target="_blank"><b>Mobile App</b></a>.</p>
               <p class="details">3. Enter school web portal URL: <strong><a href="https://canossa.campuscare.info/" target="_blank">“canossa.campuscare.info”</a>
                  </strong> in link bar &amp; verify.
               </p>
               <p class="details">4. After verifying, you will get an option for User ID &amp; Password.</p>
               <p class="details">Once logged in, you are welcomed with various information relating to assignments, news. circulars, date sheet, fee details etc that are self Explanatory. Wish you to go through every links that are provided and explore more.</p>
               <p class="details"><strong  >NOTE* :</strong> Kindly update your <a href="https://www.entab.in/mobile-apps.html" target="_blank"><b>Mobile Apps</b></a> time to time to avoid difficulties during usage.</p>
            </div>
            <div class="clr10"></div>
            <div class="assistance">
               <h5 class="guideheading">Please call or write for assistance:</h5>
               <p class="details"><strong> <a href="https://www.entab.in/contact-us.html" target="_blank">PARENT HELP DESK</a></strong> ( 8 AM to 8:00 PM ) <strong> E-Mail :</strong>
                  <strong><a class="yellow-link" href="mailto:parentdesk@entab.in"> parentdesk@entab.in</a></strong>
               </p>
            </div>
         </div>
      </div>
   </div>
</div>
</>
)
}
export default Pphelp